module.exports = __webpack_public_path__ + "335dbdff66812511a33fd0d4836f611f.png";


//////////////////
// WEBPACK FOOTER
// ./directives/footer/logo.png
// module id = 257
// module chunks = 0